import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

type Props = {
  onClose: (isConfirmed: boolean) => void,
  message: string | JSX.Element,
};
export default function DeleteConfirmationDialog({ onClose, message }: Props) {
  return (
    <Dialog open={true} maxWidth={'xs'} onClose={() => onClose(false)}>
      <DialogTitle>
        Confirm Delete
      </DialogTitle>
      <DialogContent dividers>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          sx={{ width: 100, color: "#fff" }}
          onClick={() => onClose(true)}
        >
          Delete
        </Button>
        <Button
          variant="text"
          color="inherit"
          onClick={() => onClose(false)}
          sx={{ width: 100 }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
